export const projectsData = [
  {
    title: 'Projeto Helpet - Digital House',
    year: '2022',
    description:
      'Participei ativamente do desenvolvimento do projeto Helpet, um website dedicado a aproximar abrigos de animais e doadores. Utilizando JavaScript e Node.js para o desenvolvimento, o projeto incorporou um banco de dados MySQL e os frameworks Express e Sequelize. Fiquei responsável pela implementação de funcionalidades de exclusão, cadastro e edição. Além de auxiliar na integração do back-end com o front-end.',
  },
  {
    title: 'Catálogo de Séries - Fatec',
    year: '2023',
    description:
      'Desenvolvi um site de catálogo de séries utilizando PHP no back-end, além de HTML, CSS e MySQL. Contribuí para criar uma plataforma intuitiva que permite cadastrar, editar, deletar e alterar informações sobre séries de TV. Aprimorando minhas habilidades em outra linguagem de forma prática.',
  },
  {
    title: 'Projeto Controle de Gastos Pessoais - Rocketseat',
    year: '2023',
    description:
      'Desenvolvi um aplicativo de controle de despesas pessoais em React. Destaquei-me na implementação de uma interface dinâmica e responsiva, utilizando styled-components para estilização e integrando as rotas no React.',
  },
  {
    title: 'Micro SaaS  - Rocketseat',
    year: '2025',
    description:
      'Participei do desenvolvimento de um projeto de Micro SaaS, utilizando Next.js 15, Tailwind CSS, Firebase, para pagamentos foi utilizado o Stripe. Além de implementar o analytics, focar no SEO da página, e integrar o provider de autenticação do google para o login.',
    link: 'https://project-in-bio-nu.vercel.app/',
  },
];
export const experienceData = [
  {
    title: 'Estágio Front-end - Mestres da Web',
    year: '02/2024 - 09/2024',
    description:
      'Responsável pelo desenvolvimento de toda a interfaces através do Next/React, estilização das páginas com styled-components, e integração de APIs com o Back-End.',
  },
  {
    title: 'Desenvolvedor Front-end Júnior - Mestres da Web',
    year: '09/2024 - atualmente',
    description:
      'Interfaces responsivas utilizando Next/React e integração de APIs com o Back-End, além de integrar APIs externas de autenticação e localização.',
  },
];
